var render = function render(){var _vm=this,_c=_vm._self._c;return _c('format',{attrs:{"msg":_vm.$t('online-casino'),"type-game":2,"src":require('@/assets/nav/submenu/icon_submenu2.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }